import e from"./global.js";import l from"./is-callable.js";var r=e,t=l,a=r.WeakMap,o=t(a)&&/native code/.test(String(a));export{o as default};
